// extracted by mini-css-extract-plugin
module.exports = {"nowrap":"_28U4c7r_e9hlXLp-DzViGw"};